import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Plus, Trash2 } from 'lucide-react';
import { API } from '../lib/api';
import { toast } from 'sonner';

const empty = { make: '', model: '', license_plate: '', category: 'Mittelklasse', daily_rate: 0, available: true, notes: '' };

export default function AdminVehicles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(empty);

  const load = async () => {
    setLoading(true);
    try { const { data } = await API.get('/admin/vehicles'); setItems(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const create = async (e) => {
    e.preventDefault();
    try {
      await API.post('/admin/vehicles', { ...form, daily_rate: Number(form.daily_rate || 0) });
      setForm(empty);
      toast.success('Fahrzeug hinzugefügt');
      load();
    } catch (err) { toast.error('Fehler'); }
  };

  const toggleAvail = async (v) => {
    try { await API.patch(`/admin/vehicles/${v.id}`, { available: !v.available }); load(); } catch (e) { toast.error('Fehler'); }
  };
  const remove = async (id) => {
    if (!window.confirm('Wirklich löschen?')) return;
    try { await API.delete(`/admin/vehicles/${id}`); load(); } catch (e) { toast.error('Fehler'); }
  };

  return (
    <div className="space-y-4" data-testid="admin-vehicles">
      <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Ersatzfahrzeuge</h1>
      <Card className="rounded-2xl border-slate-200">
        <CardContent className="p-5">
          <form onSubmit={create} className="grid sm:grid-cols-6 gap-2 items-end">
            <div className="sm:col-span-2"><Label>Marke</Label><Input value={form.make} onChange={(e) => set('make', e.target.value)} required className="h-10 rounded-xl mt-1" /></div>
            <div className="sm:col-span-2"><Label>Modell</Label><Input value={form.model} onChange={(e) => set('model', e.target.value)} required className="h-10 rounded-xl mt-1" /></div>
            <div><Label>Kennzeichen</Label><Input value={form.license_plate} onChange={(e) => set('license_plate', e.target.value.toUpperCase())} required className="h-10 rounded-xl mt-1 uppercase" /></div>
            <div><Label>Tagesrate (€)</Label><Input type="number" value={form.daily_rate} onChange={(e) => set('daily_rate', e.target.value)} className="h-10 rounded-xl mt-1" /></div>
            <div className="sm:col-span-6"><Button type="submit" className="bg-[hsl(var(--accent))] hover:bg-[hsl(217_90%_48%)] text-white" data-testid="admin-vehicle-add-button"><Plus className="h-4 w-4 mr-1.5" /> Fahrzeug hinzufügen</Button></div>
          </form>
        </CardContent>
      </Card>

      <Card className="rounded-2xl border-slate-200">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="admin-vehicles-table">
              <thead className="bg-slate-50"><tr className="text-left text-slate-600"><th className="px-4 py-3">Marke / Modell</th><th className="px-4 py-3">Kennzeichen</th><th className="px-4 py-3">Kategorie</th><th className="px-4 py-3">Rate</th><th className="px-4 py-3">Verfügbar</th><th className="px-4 py-3"></th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={6} className="px-4 py-6 text-slate-500">Lade...</td></tr> : items.length === 0 ? <tr><td colSpan={6} className="px-4 py-6 text-slate-500">Keine Fahrzeuge.</td></tr> : items.map((v) => (
                  <tr key={v.id} className="border-t border-slate-100 hover:bg-slate-50">
                    <td className="px-4 py-3">{v.make} {v.model}</td>
                    <td className="px-4 py-3 font-mono">{v.license_plate}</td>
                    <td className="px-4 py-3">{v.category}</td>
                    <td className="px-4 py-3">{(v.daily_rate || 0).toFixed(2)} €</td>
                    <td className="px-4 py-3"><button onClick={() => toggleAvail(v)} className={`px-2.5 py-1 rounded-full text-xs font-medium ${v.available ? 'bg-green-100 text-green-900' : 'bg-slate-200 text-slate-700'}`}>{v.available ? 'Verfügbar' : 'Nicht verfügbar'}</button></td>
                    <td className="px-4 py-3 text-right"><Button variant="ghost" size="icon" onClick={() => remove(v.id)} aria-label="Löschen"><Trash2 className="h-4 w-4 text-red-600" /></Button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
